<template>
  <div class="table-empty">
    <InitialAvatarIcon class="table-empty__icon" icon="ED0030" size="large" />
    <BaseText size="md" :color="NebraskaColors.textSecondary">
      {{ title }}
    </BaseText>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { InitialAvatarIcon, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: { InitialAvatarIcon, BaseText }
})
export default class StatementEmpty extends Vue {
  @Prop({ type: Boolean, required: false, default: false })
  readonly hasAppliedFilters!: boolean;

  readonly NebraskaColors = NebraskaColors;

  get title() {
    return this.hasAppliedFilters
      ? 'Nenhum resultado encontrado'
      : 'Você ainda não possui movimentações';
  }
}
</script>

<style lang="less" scoped>
.table-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: @size-spacing-x1200 0;

  &__icon {
    color: @element-primary;
    background-color: @neutral-secondary;
    margin-bottom: @size-spacing-x400;
  }
}
</style>
